export const siteInfo = {
  name: '黑料大赛',
  slogan: '参赛作品合集围观站',
  description:
    '黑料大赛参赛作品一站看全。按热度整理作品合集与投稿展示，热门作品榜、选手盘点持续更新，想围观高质量爆料现场，直接进来。',
  email: 'heiliaodasai@example.com',
  cooperation: 'heiliaodasai@example.com',
  updatedAt: '2026-09-08',
  season: {
    name: '第三季',
    phase: '作品持续征集中',
    startDate: '2026-07-15',
    endDate: '2026-10-30',
    submitted: 1682,
    reviewed: 1246,
    published: 214,
  },
};

export const tickerItems = [
  '第三季最新一批投稿已完成初审',
  '本周新增作品 37 篇，含 6 篇深度盘点',
  '热门作品榜更新时间：每日 09:00 / 18:00',
  '选手盘点「夜航船」专题已上线',
  '收录标准已更新，请投稿页查看细则',
];

export const stats = [
  { label: '累计投稿', value: '1,682', suffix: '篇' },
  { label: '已过审作品', value: '1,246', suffix: '篇' },
  { label: '公开作品', value: '214', suffix: '篇' },
  { label: '活跃选手', value: '96', suffix: '位' },
];

export const contentPrinciples = [
  {
    icon: 'ri-shield-check-line',
    title: '来源可查',
    desc: '每篇作品都标注信息来源层级，能核实的写清楚，不能核实的单独列出来，不混为一谈。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '不作定论',
    desc: '平台鼓励摆事实、列时间线，不鼓励替读者下结论。有争议的部分，一律保留多方说法。',
  },
  {
    icon: 'ri-file-forbid-line',
    title: '拒绝越界',
    desc: '涉及个人隐私、身份信息与未经证实指控的内容，不予公开。作品集中在公开事件与行业观察。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续更正',
    desc: '若后续出现新的公开信息，作品会标注更正记录，保留原始版本，方便读者对照查看。',
  },
];

export const testimonials = [
  {
    id: 't-01',
    name: '追更党 · 阿枝',
    role: '从第一季追到现在',
    avatar: '阿',
    text: '最大的感受是这里的时间线做得真细。同一件事在别的地方只有截图，这里会把顺序理清楚，看起来省心很多。',
  },
  {
    id: 't-02',
    name: '内容从业者 · 老周',
    role: '公关行业从业者',
    avatar: '周',
    text: '商务和公关那几篇挺实用的，作者不站队，把条款和时间点摆出来，比很多情绪化的帖子强太多。',
  },
  {
    id: 't-03',
    name: '围观路人 · 小满',
    role: '路过看到榜单进来',
    avatar: '满',
    text: '我是冲着热门作品榜来的，结果顺手把选手盘点也看完了。每个选手的风格标签很准，找自己喜欢的那种很快。',
  },
  {
    id: 't-04',
    name: '老读者 · 沉舟',
    role: '连续围观三季',
    avatar: '舟',
    text: '最喜欢它有分寸。该说的说清楚，不该放的不放，看久了反而更信这个站的内容。',
  },
];

export const faqs = [
  {
    q: '黑料大赛的作品是怎么选出来的？',
    a: '每篇投稿先过初审，检查来源是否可查、表述是否符合收录标准，再进入编辑复核。通过复核的作品才会进入公开合集，热门作品榜按浏览、点赞与讨论热度综合计算，每日更新两次。',
  },
  {
    q: '作品合集为什么有时候同一件事有好几篇？',
    a: '不同选手的切入角度往往不一样。有人擅长整理时间线，有人擅长对照公开声明，平台鼓励从不同角度还原同一件事，读者可以互相参照着看，比单一说法更完整。',
  },
  {
    q: '热门作品榜的计算方式是怎样的？',
    a: '榜单综合考虑三部分：单位时间内的浏览增量、点赞与收藏比例、以及评论区讨论的持续时长。单纯堆浏览量不容易排上去，长尾讨论反而更占优势。',
  },
  {
    q: '选手盘点里的热度标签是什么意思？',
    a: '热度反映的是该选手近三十天作品的综合表现，不是永久排名，也不代表作品质量高低。榜单会随新作品上线而变动，适合用来发现最近更新勤快的选手。',
  },
  {
    q: '我可以在站内直接投稿吗？',
    a: '当前版本以作品展示与围观为主。想参与投稿或合作，可以发邮件联系我们，说明作品主题和大致内容，编辑会回复收录标准和排期。',
  },
  {
    q: '平台会公开投稿人的个人信息吗？',
    a: '不会。所有选手均以昵称形式出现，联系方式仅用于内部沟通，不对外展示。涉及个人隐私与身份信息的内容一律不予收录。',
  },
];